import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";

export function useCancelSubscriptionMutation(onDone) {
  const mutationFactory = useCallback(() => {
    const query = `mutation cancelSubscription($subscriptionId: ID!, $refund: Boolean) {
        cancelSubscription(subscriptionId: $subscriptionId, refund: $refund) {
          successMessage
        }
      }`;

    const resolver = ({ data: { cancelSubscription } }) => {
      return { data: cancelSubscription };
    };

    return { query, resolver };
  }, []);

  const [mutation, { loading }] = useMutationWithToaster(mutationFactory, {
    onDone,
  });

  const cancelSubscription = (subscriptionId, refund) => {
    return mutation(
      { subscriptionId, refund },
      {
        successMsg: "Successfully cancelled your subscription.",
        defaultErrorMsg: "Failed to cancel your subscription.",
        context: { userRequestedRefund: refund },
      }
    );
  };

  return { cancelSubscription, loading };
}

export default useCancelSubscriptionMutation;
